import { useRef as u, useEffect as c } from "react";
function n(e, t) {
  const r = u(null);
  c(() => {
    t(r.current, e), r.current = e;
  }, [e]);
}
export {
  n as useStateWatcher
};
